// efforts.js

/**
 * Position your effort cards based on the active year,
 * using different offsets for desktop vs mobile.
 */
function layoutEffortsByYear(currentYear) {
  const efforts = Array.from(document.querySelectorAll('.effort'));
  const wrapper = document.querySelector('.efforts');
  // Remove the allstacked class whenever laying out by a specific year
  if (wrapper) wrapper.classList.remove('allstacked');

  const isMobile = window.innerWidth < 768;

  // Mobile vs Desktop spacings
  const STACK_OFFSET        = isMobile ? 5  : 20;   // overlap per stacked
  const ACTIVE_GAP          = isMobile ? 85 : 170;  // gap per active
  const ACTIVE_BUFFER       = isMobile ? 5  : 40;   // gap before active zone
  const MOBILE_EXTRA_SHIFT  = STACK_OFFSET;          // shift per stacked on mobile

  // 1) Count how many items will be stacked
  let stackedCount = 0;
  efforts.forEach(el => {
    const year = parseInt(el.dataset.year, 10);
    if (year < currentYear) stackedCount++;
  });

  // 2) If mobile, compute an extra negative base offset
  //    so that the whole stack moves leftwards
  const baseOffset = isMobile
    ? -(stackedCount * MOBILE_EXTRA_SHIFT)
    : 0;

  // 3) Position stacked items
  let s = 0;
  efforts.forEach(el => {
    const year = parseInt(el.dataset.year, 10);
    el.classList.remove('stacked', 'active', 'invisible');

    if (year < currentYear) {
      el.classList.add('stacked');
      const left = baseOffset + (s * STACK_OFFSET);
      el.style.left = `${left}px`;
      el.style.top  = `0`;
      s++;
    }
  });

  // 4) Position active items after the stacked block
  const activeStart = baseOffset + (stackedCount * STACK_OFFSET) + ACTIVE_BUFFER;
  let a = 0;
  efforts.forEach(el => {
    const year = parseInt(el.dataset.year, 10);

    if (year === currentYear) {
      el.classList.add('active');
      const left = activeStart + (a * ACTIVE_GAP);
      el.style.left = `${left}px`;
      el.style.top  = `0`;
      a++;
    }
    else if (year > currentYear) {
      el.classList.add('invisible');
      el.style.left = `110vw`;
      el.style.top  = `0`;
    }
  });
}

/**
 * Hide every effort card off-screen, and clear the allstacked flag.
 */
function hideAllEfforts() {
  const wrapper = document.querySelector('.efforts');
  if (wrapper) wrapper.classList.remove('allstacked');

  document.querySelectorAll('.effort').forEach(el => {
    el.classList.remove('stacked', 'active');
    el.classList.add('invisible');
    el.style.left = '110vw';
    el.style.top  = '0';
  });
}

/**
 * Stack all efforts neatly on-screen, and set the allstacked flag.
 */
function stackAllEfforts() {
  const wrapper = document.querySelector('.efforts');
  if (wrapper) wrapper.classList.add('allstacked');

  const isMobile     = window.innerWidth < 768;
  const STACK_OFFSET = isMobile ? 5 : 20;

  document.querySelectorAll('.effort').forEach((el, index) => {
    el.classList.remove('active', 'invisible');
    el.classList.add('stacked');
    el.style.left = `${index * STACK_OFFSET}px`;
    el.style.top  = `0`;
  });
}

// Expose globally
window.layoutEffortsByYear = layoutEffortsByYear;
window.hideAllEfforts         = hideAllEfforts;
window.stackAllEfforts        = stackAllEfforts;